"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
function NotFoundPage() {
    var navigate = (0, react_router_dom_1.useNavigate)();
    function handleNavigate() {
        navigate("/");
    }
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "404 - Page Not Found" }), (0, jsx_runtime_1.jsx)("p", { children: "The page you are looking for does not exist." }), (0, jsx_runtime_1.jsx)("button", { onClick: handleNavigate, children: "Back" })] }));
}
exports.default = NotFoundPage;
